import Input from "../../components/Input";
import Select from "../../components/Select";

export default function JuniorFields({
	translate,
	lang,
	data,
	handleUpdate,
	errors,
}) {
	return (
		<>
			<div className="form-group">
				<Input
					name="fname"
					label={translate(lang, "Nombre(s)", "Nombre(s)")}
					reqd={true}
					value={data.fname || ""}
					update={handleUpdate}
					errors={errors}
					autocomplete="off"
				/>

				<Input
					name="lname"
					label={translate(lang, "Apellidos", "Apellidos")}
					reqd={true}
					value={data.lname || ""}
					update={handleUpdate}
					errors={errors}
					autocomplete="off"
				/>
			</div>

			<div className="form-group">
				<div className="form-group three dob">
					<Select
						name="dobDay"
						label={translate(lang, "Date of Birth", "Fecha de Nacimiento")}
						reqd={true}
						value={data.dobDay || ""}
						options={[
							{
								id: "",
								name: "--",
							},
						].concat(
							Array(31)
								.fill()
								.map((_, index) => index + 1)
								.map((item) => {
									return {
										id: item,
										name: item,
									};
								}),
						)}
						update={handleUpdate}
						errors={errors}
						autocomplete="off"
					/>
					<Select
						name="dobMonth"
						label={translate(lang, "&nbsp;", "&nbsp;")}
						reqd={false}
						value={data.dobMonth || ""}
						options={[
							{
								id: "",
								name: "--",
							},
						].concat(
							[
								"enero",
								"febrero",
								"marzo",
								"abril",
								"mayo",
								"junio",
								"julio",
								"agosto",
								"septiembre",
								"octubre",
								"noviembre",
								"diciembre",
							].map((item, index) => {
								return {
									id: index + 1,
									name: item,
								};
							}),
						)}
						update={handleUpdate}
						errors={errors}
						autocomplete="off"
					/>
					<Select
						name="dobYear"
						label={translate(lang, "&nbsp;", "&nbsp;")}
						reqd={false}
						value={data.dobYear || ""}
						options={[
							{
								id: "",
								name: "--",
							},
						].concat(
							[
								"2007",
								"2008",
								"2009",
								"2010",
								"2011",
								"2012",
								"2013",
								"2014",
								"2015",
								"2016",
								"2017",
								"2018",
								"2019",
								"2020",
							].map((item, index) => {
								return {
									id: item,
									name: item,
								};
							}),
						)}
						update={handleUpdate}
						errors={errors}
						autocomplete="off"
					/>
				</div>
				<div className="empty" />
			</div>

			<div className="form-group">
				<Input
					name="hometown"
					label={translate(lang, "Ciudad de Origen", "Ciudad de Origen")}
					reqd={true}
					value={data.hometown || ""}
					update={handleUpdate}
					errors={errors}
					autocomplete="address-level2"
				/>

				<Select
					name="st1"
					label={translate(lang, "State", "Estado")}
					reqd={true}
					value={data.st1 || ""}
					options={[
						{
							id: "",
							name: "--",
						},
					].concat(
						[
							"Aguascalientes",
							"Baja California",
							"Baja California Sur",
							"Campeche",
							"Chiapas",
							"Chihuahua",
							"Coahuila",
							"Colima",
							"Durango",
							"Guanajuato",
							"Guerrero",
							"Hidalgo",
							"Jalisco",
							"México",
							"Mexico City",
							"Michoacán",
							"Morelos",
							"Nayarit",
							"Nuevo León",
							"Oaxaca",
							"Puebla",
							"Querétaro",
							"Quintana Roo",
							"San Luis Potosí",
							"Sinaloa",
							"Sonora",
							"Tabasco",
							"Tamaulipas",
							"Tlaxcala",
							"Veracruz",
							"Yucatán",
							"Zacatecas",
						].map((item) => {
							return {
								id: item,
								name: item,
							};
						}),
					)}
					update={handleUpdate}
					errors={errors}
					autocomplete="address-level1"
				/>
			</div>
		</>
	);
}
